import React from 'react';
import styled, { css } from 'styled-components';
import Row from '~/components/organism/Table/components/Row';

const FakeRow: React.FCC = ({ children }) => (
  <Container to="/-/">{children}</Container>
);

const Container = styled(Row)(
  ({ theme }) => css`
    cursor: wait;
    pointer-events: none;
    &:hover {
      background-color: ${theme.color('white')};
    }
  `,
);

export default FakeRow;
